import {
  call,
  takeEvery,
} from 'redux-saga/effects';
import { UndoItemType } from '~/_shared/types/undo/undoItem';
import { type PickAction } from '~/_shared/utils/types/action.type';
import { type StorageService } from '../../../_shared/utils/storageService';
import { createHistoryItem } from '../../undo/undo.helpers';
import { getUserStorageService } from '../../userData/userData.sagas';
import { type MapSettingsDirectionsAction } from './mapSettingsDirections.action';
import { removeRouteFromDirections } from './mapSettingsDirections.actionCreators';

export function* mapSettingsDirectionsSaga() {
  yield takeEvery(removeRouteFromDirections, removeRouteSaga);
}

function* removeRouteSaga(action: PickAction<MapSettingsDirectionsAction, typeof removeRouteFromDirections.type>) {
  const storageService: StorageService = yield call(getUserStorageService);

  yield call(createHistoryItem, storageService, { type: UndoItemType.REMOVE_ROUTE, data: action.payload.route, mapId: action.payload.mapId });
}
